import React from 'react';
import { Box, Chip, Paper, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { TaskLoadingDependenciesFinishedPayload } from '../../hooks/taskLoadingMetrics/TaskLoadingMetricsContext';

const useStyles = makeStyles(() => ({
  container: {
    padding: '8px 12px',
    marginBottom: '8px',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flexWrap: 'wrap',
  },
  totalTime: {
    fontWeight: 'bold',
    fontSize: '1.1rem',
  },
  metricsRow: {
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap',
    alignItems: 'center',
  },
}));

interface Props {
  metrics: TaskLoadingDependenciesFinishedPayload | null;
}

const TaskLoadingMetricsDisplay: React.FC<Props> = ({ metrics }) => {
  const classes = useStyles();

  if (!metrics || !process.env.REACT_APP_DEBUG_MODE) return null;

  const formatMs = (ms: number) => ms < 1000 ? `${ms}ms` : `${(ms / 1000).toFixed(2)}s`;
  const getColor = (ms: number): 'success' | 'warning' | 'error' => {
    if (ms <= 150) return 'success';
    if (ms <= 400) return 'warning';
    return 'error';
  };

  return (
    <Paper className={classes.container} elevation={1}>
      <Typography variant="body2" className={classes.totalTime}>
        📊 Task Loaded: {formatMs(metrics.taskLoadedCompleteMs)}
      </Typography>
      <Box className={classes.metricsRow}>
        <Chip size="small" label={`Ack: ${formatMs(metrics.acknowledgementToPageTransitionMs)}`} color={getColor(metrics.acknowledgementToPageTransitionMs)} />
        <Chip size="small" label={`Menu DL: ${formatMs(metrics.menuDownloadMs)}`} color={getColor(metrics.menuDownloadMs)} />
        <Chip size="small" label={`Menu Load: ${formatMs(metrics.menuProcessingMs)}`} color={getColor(metrics.menuProcessingMs)} />
        <Chip size="small" label={`Audio: ${formatMs(metrics.audioBackendConnectionMs)}`} color={getColor(metrics.audioBackendConnectionMs)} />
        <Chip size="small" label={`Events: ${formatMs(metrics.eventsBackendConnectionMs)}`} color={getColor(metrics.eventsBackendConnectionMs)} />
      </Box>
      <Typography variant="caption" color="textSecondary">
        {metrics.restaurantCode} | {new Date(metrics.timestamp).toLocaleTimeString()}
      </Typography>
    </Paper>
  );
};

export default TaskLoadingMetricsDisplay;
